import label from "@/lang/StaticLabels.js";

export default {
  token: null,
  loginCheck: false,

  registerToken: null,
  registerCode: null,
  checkNewRegister: false,
  forgotCode: null,
  captcha: {},

  imageUrl: [],
  multipleImage: [],
  multipleImage2: [],
  thumbUrl: [],
  fileUrl: [],
  videoUrl: [],
  soundUrl: [],
  url: [],

  addUploaderCheck: false,

  ///////////////////////////////////////////////////
  userProfile: {},
  fiscalYear: {},

  postCheck: false,
  checkAlert: 0,
  successMessage: null,
  warningMessage: null,
  infoMessage: null,
  dangerMessage: null,

  loadingCheck: 0,
  loadingMessage: label.caption.loading,
  loadingBtn: false,

  selectedFiscalYear: localStorage.getItem("PCMSAdminLanguage"),
  forgotCheck: false,
};
